import velocity from 'velocity-animate';

const easing = 'easeOutQuart';
const duration = 300;

let velocityHelper = (el, animation, done) => {
    velocity(el, animation, {
        easing: easing,
        duration: duration,
        complete: done
    });
};

export default {
    fadeIn(el, done) {
        velocityHelper(el, 'fadeIn', done);
    },
    fadeOut(el, done) {
        velocityHelper(el, 'fadeOut', done);
    },
    slideUp(el, done) {
        velocityHelper(el, 'slideUp', done);
    },
    slideDown(el, done) {
        velocityHelper(el, 'slideDown', done);
    }
}